var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanies3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.97833V7.16667C2 4.86917 3.86917 3 6.16667 3H8.27333C8.65917 3 9.04583 3.09083 9.39083 3.26333L12.0208 4.57833C12.1358 4.63583 12.2642 4.66583 12.3925 4.66583H17.8325C19.8367 4.66583 21.5142 6.08917 21.9092 7.9775L2 7.97833ZM22 9.645V17.1667C22 19.4642 20.1308 21.3333 17.8333 21.3333H6.16667C3.86917 21.3333 2 19.4642 2 17.1667V9.645H22ZM15.3333 15.4783C15.3333 15.0175 14.9608 14.645 14.5 14.645H9.5C8.41 14.6492 8.41083 16.3075 9.5 16.3117H14.5C14.9608 16.3117 15.3333 15.9392 15.3333 15.4783Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies3);
export default __webpack_public_path__ + "static/media/companies3.de3a2886.svg";
export { ForwardRef as ReactComponent };